var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "select"
  }, [_vm.wayType === 'phone' || _vm.wayType === 'email' ? _c('div', {
    staticClass: "which"
  }, [_c('div', {
    staticClass: "ph-em",
    class: {
      selected: _vm.wayType === 'email'
    },
    on: {
      "click": function click($event) {
        return _vm.selectWay('email');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.email'))))])]), _c('div', {
    staticClass: "ph-em",
    class: {
      selected: _vm.wayType === 'phone'
    },
    on: {
      "click": function click($event) {
        return _vm.selectWay('phone');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phone'))))])]), _vm._v(" "), _c('div', {
    staticClass: "blue",
    class: {
      'email': _vm.wayType === 'email',
      'phone': _vm.wayType === 'phone'
    }
  })]) : _c('div', {
    staticClass: "which mb"
  }, [_c('div', {
    staticClass: "abtn ebtn",
    on: {
      "click": function click($event) {
        return _vm.selectWay('m-email');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.email'))))]), _vm._v(" "), _c('div', {
    staticClass: "abtn pbtn",
    on: {
      "click": function click($event) {
        return _vm.selectWay('m-phone');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phone'))))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };